"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const dateFormat = require("dateformat");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const fluxible_router_1 = require("fluxible-router");
const BlogStore_1 = require("../stores/BlogStore");
const CommentForm_1 = require("./partials/CommentForm");
const SideBar_1 = require("./SideBar");
const ApplicationStore_1 = require("../stores/ApplicationStore");
const helper_1 = require("../helper");
const gravatar = require("gravatar");
const BlogActions_1 = require("../actions/BlogActions");
const react_loading_skeleton_1 = require("react-loading-skeleton");
const clientDebug_1 = require("../clientDebug");
const react_helmet_1 = require("react-helmet");
const $ = require("jquery");
class SinglePost extends React.Component {
    constructor() {
        super(...arguments);
        this.sliderheight = () => {
            $('.carousel').each((i, carousel) => {
                const $carousel = $(carousel);
                function setDivHeight($elem) {
                    try {
                        const divHeight = $elem.height();
                        const divWidth = $elem.width();
                        $carousel.css({ height: divHeight, width: divWidth });
                    }
                    catch (_a) {
                    }
                }
                $carousel.find('.slide').find('img').first().each((_, img) => {
                    $(img).on('load', function () {
                        setDivHeight($(this));
                    });
                    if (img.complete) {
                        setDivHeight($(img));
                    }
                });
            });
        };
        this.onPostLoad = () => {
            this.sliderheight();
            if (this.props.post && this.props.post.title) {
                (0, clientDebug_1.sendEvent)('GetBlogPostClient', { post: this.props.post.title });
            }
        };
    }
    goToLink(url) {
        this.props.executeAction(fluxible_router_1.navigateAction, {
            url: url.replace('../..', '').replace('..', ''),
            method: 'GET',
        });
    }
    componentDidMount() {
        const self = this;
        $('.post-body').on('click', '.linkable', function (e) {
            e.preventDefault();
            self.goToLink($(this).attr('href'));
        });
        $(window).resize(this.sliderheight);
        this.onPostLoad();
    }
    componentWillUnmount() {
        $(window).off('resize', this.sliderheight);
        this.props.executeAction(BlogActions_1.default.unmountSinglePost);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.post.textExtended !== prevProps.post.textExtended) {
            this.onPostLoad();
        }
    }
    render() {
        const post = this.props.post;
        const url = this.props.host + '/post/' + this.props.post.slug;
        const imageUrl = post.image != null ? post.image.secure_url : null;
        const description = post.textBrief.replace(/<[^>]+>/g, '');
        if (post == null) {
            this.props.executeAction(fluxible_router_1.navigateAction, {
                url: '/404',
                method: 'GET',
            });
            return null;
        }
        let title = `${this.props.post.title} - ${this.props.siteTitle}`;
        if (post.textBrief === 'loading') {
            title = 'Loading';
        }
        return (React.createElement("section", { className: 'blog-content blog-standard' },
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("title", null, title),
                imageUrl ? React.createElement("meta", { name: 'twitter:card', content: 'summary_large_image' }) :
                    React.createElement("meta", { name: 'twitter:card', content: 'summary' }),
                imageUrl && React.createElement("meta", { name: 'og:image', content: imageUrl }),
                this.props.twitterName && React.createElement("meta", { name: 'twitter:site', content: this.props.twitterName }),
                this.props.twitterName && React.createElement("meta", { name: 'twitter:creator', content: this.props.twitterName }),
                React.createElement("meta", { property: 'og:url', content: this.props.host + '/post/' + post.slug }),
                React.createElement("meta", { property: 'og:title', content: title }),
                React.createElement("meta", { property: 'og:type', content: 'article' }),
                React.createElement("meta", { property: 'og:description', content: description }),
                React.createElement("meta", { property: 'description', content: description })),
            React.createElement("div", { className: 'container' },
                React.createElement("div", { className: 'row' },
                    React.createElement("div", { className: 'col-md-9' },
                        React.createElement("div", { className: 'content' },
                            React.createElement("div", { className: 'post type-post status-publish format-image has-post-thumbnail hentry category-destinations tag-beach tag-croatia post_format-post-format-image' },
                                post.textBrief !== 'loading' ? (post.image ?
                                    React.createElement("div", { className: 'post-media' },
                                        React.createElement("div", { className: 'image-wrap' },
                                            React.createElement("img", { src: (0, helper_1.convertImageUrl)(post.image.secure_url), alt: 'Image' })))
                                    : null) : React.createElement("div", { className: 'post-media' },
                                    React.createElement("div", { className: 'image-wrap' },
                                        React.createElement(react_loading_skeleton_1.default, { height: 400 }))),
                                React.createElement("div", { className: 'post-body' },
                                    post.categories != null ?
                                        React.createElement("div", { className: 'post-cat' },
                                            React.createElement("ul", null, post.categories.map((category) => React.createElement("li", { key: category.key },
                                                React.createElement(fluxible_router_1.NavLink, { href: '/blog?category=' + category.name }, category.name))))) : null,
                                    React.createElement("div", { className: 'post-title' },
                                        React.createElement("h1", null, post.title)),
                                    React.createElement("div", { className: 'post-date' },
                                        React.createElement("span", null, dateFormat(post.publishedDate, 'mmmm dS, yyyy'))),
                                    post.textBrief !== 'loading' ?
                                        React.createElement("div", { className: 'post-entry', dangerouslySetInnerHTML: { __html: post.textExtended || post.textBrief } }) :
                                        React.createElement(react_loading_skeleton_1.default, { count: 10 })),
                                React.createElement("div", { className: 'tag-share' },
                                    post.tags != null ?
                                        React.createElement("div", { className: 'tag-box' },
                                            React.createElement("h4", null, "Tag"),
                                            React.createElement("div", { className: 'tag' }, post.tags.map((tag) => {
                                                return (React.createElement(fluxible_router_1.NavLink, { key: tag, href: '/blog?tag=' + tag }, tag));
                                            }))) : null,
                                    React.createElement("div", { className: 'share-box' },
                                        React.createElement("h4", null, "Share"),
                                        React.createElement("div", { className: 'share' },
                                            React.createElement("a", { target: '_blank', href: 'https://www.facebook.com/sharer/sharer.php?u=' + url + '=popup&ref=plugin&src=like&kid_directed_site=0' },
                                                React.createElement("i", { className: 'fa fa-facebook' })),
                                            React.createElement("a", { target: '_blank', href: 'https://twitter.com/intent/tweet?text=' + post.title + ' - ' + url },
                                                React.createElement("i", { className: 'fa fa-twitter' })))))),
                            React.createElement("div", { id: 'comments' },
                                React.createElement("div", { className: 'comments-inner-wrap' },
                                    React.createElement("h4", { id: 'comments-title' },
                                        post.comments.length,
                                        " Comments"),
                                    React.createElement("ul", { className: 'commentlist' }, post.comments.map((comment) => {
                                        const gravatarUrl = gravatar.url(comment.author.email, {
                                            protocol: 'https',
                                            s: '80',
                                        });
                                        const defaultUrl = '/public/img/defaultUser.png';
                                        return (React.createElement("li", { key: comment._id, className: 'comment' },
                                            React.createElement("div", { className: 'comment-box' },
                                                React.createElement("div", { className: 'comment-author' },
                                                    React.createElement("a", { href: '#' },
                                                        React.createElement("img", { src: gravatarUrl, alt: 'Image' }))),
                                                React.createElement("div", { className: 'comment-body' },
                                                    React.createElement("cite", { className: 'fn' },
                                                        React.createElement("a", { href: '#' }, comment.author.name)),
                                                    React.createElement("p", null, comment.content),
                                                    React.createElement("div", { className: 'comment-meta' },
                                                        React.createElement("span", null, dateFormat(comment.publishedOn, 'dd/mm/yyyy')))))));
                                    })))),
                            React.createElement("div", { id: 'respond' },
                                React.createElement("div", { className: 'reply-title' },
                                    React.createElement("h4", null, "Leaver your comment")),
                                React.createElement(CommentForm_1.default, { postId: post._id, executeAction: this.props.executeAction })))),
                    React.createElement(SideBar_1.default, null)))));
    }
}
class SinglePostProps {
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(SinglePost, [BlogStore_1.default], (context) => {
    var _a;
    const result = {
        post: (context.getStore(BlogStore_1.default)).getSinglePost(),
        host: (context.getStore(ApplicationStore_1.default).getParam('host')),
        siteTitle: context.getStore(ApplicationStore_1.default).getParam('site_title') || 'xbimz.world',
        twitterName: (_a = context.getStore(ApplicationStore_1.default).getParam('twitter_name')) !== null && _a !== void 0 ? _a : 'Xbim_dev',
        executeAction: context.executeAction,
    };
    return result;
});
